<div class="hidden md:flex z-[1] absolute top-0 left-0 overflow-hidden h-screen bg-calm-center w-screen self-center"></div>
<div class="w-screen h-screen overflow-y-scroll flex place-content-center items-center bg-tertiary absolute top-0 left-0 z-[2] cut-bg"
    *transloco="let t">
    <div class="md:w-[350px] pb-[10vh] h-screen">
        <div title class="text-[48px] pt-[20px] font-bold text-center mx-[18px] text-primary italic">
            <img class="" [src]="'./assets/logo.png'" />
        </div>

        <div class="px-[25px] md:px-0 pt-[100px]">
            <std-input customInputClass="custom-input" customLabel="label-input" [placeholder]="t('auth.email')+ '*'"
                customContainerlass="!w-full border-b-[2px] border-primary mb-8"
                customInputClass="border-0 rounded-none" [(ngModel)]="email"
                [value]="email"></std-input>
            <std-input customInputClass="custom-input" customLabel="label-input" [placeholder]="t('auth.password')+ '*'"
                customContainerlass="!w-full border-b-[2px] border-primary mb-8"
                customInputClass="border-0" [(ngModel)]="password" id="password-login"
                [type]="showPassword ? 'text':'password'" [value]="password">
                <div iconRight class="flex place-content-center">
                    <img (mousedown)="showPassword = true" (mouseup)="showPassword=false" class="cursor-pointer"
                        src="../../assets/eye.svg">
                </div>
            </std-input>
            <div (click)="recoveryPassword()"
                class="text-[#2D2D2D] cursor-pointer w-fit mb-5 text-[12px] opacity-50 mt-[10px] ml-auto">
                {{t('auth.forgetPassword')}}</div>
        </div>
        <div class="ml-auto w-full pb-10 px-[25px] md:px-0">
            <std-button (click)="login(t)" id="button-login" size="sm"
                buttonClass="uppercase bg-primary hover:bg-primary focus:bg-primary">{{t('auth.enter')}}</std-button>
            <!-- <div  class="text-[#2D2D2D] w-fit mx-auto text-[12px] opacity-50 mt-[10px]">
                {{t('auth.or')}}</div>
            <std-button (click)="registration()" id="button-login" size="sm"
                buttonClass="uppercase bg-white hover:bg-white !text-primary shadow-xl focus:bg-white mt-2">{{t('auth.register')}}</std-button> -->
        </div>


    </div>
</div>